__turbopack_context__.v({
  "showMoreButton": "show-more-button-module-scss-module__3VXgPW__showMoreButton",
  "showMoreButton_active": "show-more-button-module-scss-module__3VXgPW__showMoreButton_active",
});
